import { BLACK_900, RED_500, GREEN_600, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getLeftRightListItemData = function getLeftRightListItemData(props, isSmallScreen, useWrappedText) {
  if (useWrappedText === void 0) {
    useWrappedText = false;
  }
  var leftDetails = props.leftDetails,
    rightDetails = props.rightDetails;
  var leftItemColor = BLACK_900;
  if ((leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.status) === 'success') leftItemColor = GREEN_600;
  if ((leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.status) === 'error') leftItemColor = RED_500;
  var rightItemColor = BLACK_900;
  if ((rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.status) === 'success') rightItemColor = GREEN_600;
  if ((rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.status) === 'error') rightItemColor = RED_500;
  var leftItemFontType = "body-" + (useWrappedText ? 'para' : 'single-line') + "-" + (isSmallScreen ? 'sm' : 'md');
  if (leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.isBold) leftItemFontType += '-bold';
  var rightItemFontType = "body-" + (useWrappedText ? 'para' : 'single-line') + "-" + (isSmallScreen ? 'sm' : 'md');
  if (rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.isBold) rightItemFontType += '-bold';
  return {
    leftItemColor,
    leftItemFontType: leftItemFontType,
    rightItemColor,
    rightItemFontType: rightItemFontType
  };
};
export var getPriceBreakupWidgetStyles = props => {
  var leftDetails = props.leftDetails;
  var spacing = tokens.spacing;
  return StyleSheet.create({
    priceBreakUpitemWrapper: {
      flex: 1
    },
    itemSpacing: {
      paddingBottom: spacing.SPACING_16
    },
    itemSpacing2: {
      marginBottom: 4
    },
    listContainer: {
      flexDirection: 'row'
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: spacing.SPACING_16
    },
    accordianContainer: {
      paddingRight: spacing.SPACING_16,
      paddingTop: spacing.SPACING_8
    },
    buttonWidgetContainer: {
      marginTop: tokens.spacing.SPACING_8,
      paddingHorizontal: spacing.SPACING_16
    },
    leftDetailsContainer: Object.assign({
      marginRight: spacing.SPACING_20,
      flex: 1
    }, (leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.marginTop) && {
      marginTop: leftDetails.marginTop
    }),
    leftDetailsItemContainer: {
      display: 'flex',
      flexDirection: 'row'
    },
    rightDetailsItemContainer: {
      display: 'flex',
      flexDirection: 'row'
    },
    rightDetailsStrikedText: {
      marginRight: 4
    },
    buttonContainer: {
      marginTop: spacing.SPACING_16
    },
    divider: {
      marginTop: spacing.SPACING_16
    },
    titleContentSpacer: {
      marginTop: spacing.SPACING_4
    },
    leftSubTextContainer: {
      marginTop: spacing.SPACING_4,
      justifyContent: 'space-between',
      flexWrap: 'wrap'
    },
    infoIconTooltip: {
      paddingLeft: spacing.SPACING_4
    },
    accordianContainerPadding: {
      paddingRight: spacing.SPACING_16
    },
    collapsibleContainer: {
      paddingRight: tokens.spacing.SPACING_0,
      paddingLeft: tokens.spacing.SPACING_16
    },
    nonCollapsibleContainer: {
      paddingHorizontal: tokens.spacing.SPACING_16
    },
    footerSection: {
      paddingTop: tokens.spacing.SPACING_20
    },
    offerStripWidget: {
      marginHorizontal: -1,
      marginBottom: -1,
      marginTop: 16
    }
  });
};